/**
 * 处理 MSG_INSTEAD_VIDEO_POP 消息（消息替代视频弹窗）
 * 当用户在聊天场景中，服务端推送此消息引导发起视频通话
 */

import { showVideoTopPop, isVideoTopPopShow } from '@/components/VideoTopPop'
import { LIVE_ROOM_COME_FROM } from '@/common/constants'
import { useGlobalStore } from '@/stores/global'
import { matchPopReport } from '@/api/video'
import { useVideoCallStore } from '@/stores/videoCall'
import router from '@/router'

const matchPopNotExposeReport = async (target_id, pop_id) => {
  await matchPopReport({
    target_id,
    pop_id,
    scene: matchPopReport.SCENE.REPLY_MESSAGE,
    status: matchPopReport.STATUS.NOT_EXPOSE,
  })
}

/**
 * 处理 MSG_INSTEAD_VIDEO_POP 消息
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export async function handleMsgInsteadVideoPop(event) {
  console.log('[handleMsgInsteadVideoPop] event:', event)
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  const message = messages[0] || {}
  const { msg_content, timestamp } = message
  const { love_invite_member } = msg_content || {}
  const pop_id = msg_content?.pop_id || message.pop_id

  if (!love_invite_member) {
    console.warn('[handleMsgInsteadVideoPop] missing love_invite_member data')
    return
  }

  // 提取用户信息
  const {
    id: targetId,
    member_id: targetMemberId,
    avatar,
    nickname,
    national_flag: nationFlag,
    nation,
  } = love_invite_member

  // 获取必要的 stores
  const globalStore = useGlobalStore()
  const videoCallStore = useVideoCallStore()

  // 从 globalStore 获取配置
  const { video_pop_delay, video_pop_show_duration } = globalStore.staticConfig?.video_pop_config || {}

  // ========== 显示限制条件检查 ==========

  // 1. 检查 APP 是否在前台
  if (!globalStore.isDocumentVisible) {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 2. 检查是否在 VIP/DIAMOND 商品页
  const currentRouteName = router.currentRoute.value.name
  if (currentRouteName === 'diamond' || currentRouteName === 'vip') {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 3. 检查是否空闲状态
  if (!videoCallStore.isIdle) {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 4. 检查 VideoTopPop 是否已经显示
  if (isVideoTopPopShow()) {
    matchPopNotExposeReport(targetId, pop_id)
    return
  }

  // 5. 时间戳校验
  if (timestamp && video_pop_delay) {
    const currentTime = Date.now()
    const diff = Math.abs(currentTime - timestamp)
    const delayMs = video_pop_delay * 1000 // 秒转毫秒

    if (diff > delayMs) {
      // 上报未曝光
      matchPopNotExposeReport(targetId, pop_id)
      return
    }
  }

  // 展示顶部横幅通知 - 组件内部会处理视频通话逻辑
  showVideoTopPop({
    autoClose: video_pop_show_duration,

    // 目标用户信息（包含显示信息和通话信息）
    targetMember: {
      id: targetId,
      member_id: targetMemberId,
      avatar,
      nickname,
      nation_flag: nationFlag,
      nation,
    },

    // 通话来源和弹窗ID
    comeFrom: LIVE_ROOM_COME_FROM.MSG_INSTEAD,
    popId: pop_id,
  })
}
